module.exports = __webpack_public_path__ + "src/assets/star-gray.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/star-gray.svg
// module id = 34
// module chunks = 0